import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoalsContext } from '../State/GoalsContext';
import { isEuSdgEnabled } from '../utils/featureFlags';
import './FrameworkSwitcher.css';

/**
 * Home-page UN / EU framework chooser (card layout with logos + selected state).
 * Copy and logo URLs come from CMS via homeCopy.framework*.
 */
const FrameworkSwitcher = ({ copy = {} }) => {
  const { goalType, setGoalType } = useContext(GoalsContext);
  const navigate = useNavigate();

  if (!isEuSdgEnabled) {
    return null;
  }

  const heading = copy.frameworkHeading || 'Choose a framework to explore';
  const selectedLabel = copy.frameworkSelectedLabel || 'Selected';

  const cards = [
    {
      type: 'un',
      title: 'Sustainable Development Goals',
      description: 'Explore the 17 Sustainable Development Goals.',
      // No UN emblem — branding uses SDG wordmark only (no UN logo).
      logo: null,
      path: '/un-sdg',
    },
    {
      type: 'eu',
      title: copy.frameworkEuTitle || 'European Union SDGs',
      description:
        copy.frameworkEuDescription ||
        'Explore the EU SDG indicators and monitoring framework.',
      logo: copy.frameworkEuLogo || '/framework-logos/eu-flag.svg',
      path: '/eu-sdg',
    },
  ];

  const select = (card) => {
    if (goalType === card.type) return;
    setGoalType(card.type);
    navigate(card.path);
  };

  return (
    <section className="framework-switcher" aria-labelledby="framework-switcher-heading">
      <h2 id="framework-switcher-heading" className="framework-switcher__heading">
        {heading}
      </h2>
      <div className="framework-switcher__grid" role="list">
        {cards.map((card) => {
          const selected = goalType === card.type;
          return (
            <button
              key={card.type}
              type="button"
              className={`framework-switcher__card${selected ? ' is-selected' : ''}`}
              aria-pressed={selected}
              aria-current={selected ? 'true' : undefined}
              onClick={() => select(card)}
            >
              {card.logo ? (
                <span className="framework-switcher__logo" aria-hidden="true">
                  <img src={card.logo} alt="" />
                </span>
              ) : null}
              <span className="framework-switcher__body">
                <span className="framework-switcher__title-row">
                  <span className="framework-switcher__title">{card.title}</span>
                  {selected ? (
                    <span className="framework-switcher__badge">{selectedLabel}</span>
                  ) : null}
                </span>
                <span className="framework-switcher__desc">{card.description}</span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default FrameworkSwitcher;
